"use strict";

;
(function () {
  // Define a method to load rudder-analytics.js from our CDN,
  // and that will be sure to only ever load it once.
  // Create an async script element based on your key.
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = 'https://cdn.rudderlabs.com/v2/rudder-analytics.min.js';

  // Insert our script next to the first script element.
  var first = document.getElementsByTagName('script')[0];
  first.parentNode.insertBefore(script, first);
})();